const DistributedIcon = ({ size = 56, isActive = false, className = "", ...props }) => {
  const fillColor = isActive ? "#68D7FF" : "#9EA6B2";
  const fillOpacity = isActive ? "0.3" : "0.3";
  const strokeColor = isActive ? "url(#paint0_linear_active)" : "url(#paint0_linear)";
  const iconColor = "white";

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 56 57" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id="paint0_linear" x1="3.95297" y1="4.90429" x2="50.7637" y2="54.9557" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint0_linear_active" x1="3.95297" y1="4.90429" x2="50.7637" y2="54.9557" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF"/>
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0"/>
        </linearGradient>
      </defs>
      
      {/* Background circle with blur effect */}
      <foreignObject x="-9.05275" y="-8.55275" width="74.1055" height="74.1055">
        <div 
          xmlns="http://www.w3.org/1999/xhtml" 
          style={{
            backdropFilter: "blur(4.53px)",
            clipPath: "url(#bgblur_clip_path)",
            height: "100%",
            width: "100%"
          }}
        />
      </foreignObject>
      
      <g data-figma-bg-blur-radius="9.05275">
        {/* Background circle */}
        <path 
          d="M28 1.5C42.9117 1.5 55 13.5883 55 28.5C55 43.4117 42.9117 55.5 28 55.5C13.0883 55.5 1 43.4117 1 28.5C1 13.5883 13.0883 1.5 28 1.5Z" 
          fill={fillColor} 
          fillOpacity={fillOpacity}
        />
        
        {/* Border stroke */}
        <path 
          d="M28 1.5C42.9117 1.5 55 13.5883 55 28.5C55 43.4117 42.9117 55.5 28 55.5C13.0883 55.5 1 43.4117 1 28.5C1 13.5883 13.0883 1.5 28 1.5Z" 
          stroke={strokeColor} 
          strokeWidth="2"
        />
        
        {/* Box/package icon - top right face */}
        <path 
          d="M28.7188 30.0254V39.7214L38.7821 34.2261C39.1623 34.0185 39.3988 33.6199 39.3988 33.1868V24.1934L28.7188 30.0254Z" 
          fill={iconColor}
        />
        
        {/* Box/package icon - top left face */}
        <path 
          d="M17.2163 34.2261L27.2796 39.7214V30.0254L16.5996 24.1934V33.1868C16.5996 33.6199 16.8361 34.0185 17.2163 34.2261Z" 
          fill={iconColor}
        />
        
        {/* Box/package icon - front face */}
        <path 
          d="M38.6792 22.9453L28.5667 17.4232C28.213 17.2301 27.7854 17.23 27.4317 17.4231L23.0312 19.8253L33.6872 25.6573L38.6792 22.9453Z" 
          fill={iconColor}
        />
        
        {/* Box/package icon - bottom face */}
        <path 
          d="M21.5203 20.665L17.3203 22.945L28.0003 28.753L32.1763 26.473L21.5203 20.665Z" 
          fill={iconColor}
        />
      </g>
      
      <defs>
        <clipPath id="bgblur_clip_path" transform="translate(9.05275 8.55275)">
          <path d="M28 1.5C42.9117 1.5 55 13.5883 55 28.5C55 43.4117 42.9117 55.5 28 55.5C13.0883 55.5 1 43.4117 1 28.5C1 13.5883 13.0883 1.5 28 1.5Z"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default DistributedIcon; 